import { render } from "./PremiumCheckoutView.vue?vue&type=template&id=6e679c50&scoped=true"
import script from "./PremiumCheckoutView.vue?vue&type=script&lang=js"
export * from "./PremiumCheckoutView.vue?vue&type=script&lang=js"

import "./PremiumCheckoutView.vue?vue&type=style&index=0&id=6e679c50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e679c50"]])

export default __exports__